import React from "react"

import KnowledgeModerationButtons from "../../../common/knowledge-list/KnowledgeModerationButtons"
import FormActionButtonsWidget from "../../../common/FormActionButtonsWidget"

const ClusterEditFormActionButtonsWidget = props => {
    const {
        canEdit,
        canSave,
        moderationStatus,
        approve,
        reject,
        unmoderate,
        isSaving
    } = props

    return (
        <FormActionButtonsWidget {...props}>
            <KnowledgeModerationButtons
                {...{
                    canSave: canSave && canEdit,
                    isSaving,
                    moderationStatus,
                    approve,
                    reject,
                    unmoderate
                }}
            />
        </FormActionButtonsWidget>
    )
}

export default ClusterEditFormActionButtonsWidget
